// Stripe Configuration
// Stripe publishable key (safe to expose in frontend code)
/////// TEST KEY ///////
// export const STRIPE_PUBLISHABLE_KEY = 'pk_test_51ShfM5Fh7MkxCDnIAsohzN0PQpE9hIjJFtfdKnsqn6authjebHGfJVXEzJA4WBvyPw0j57eNiR4JGdp7oT47GgNt00shAkHCE7';
/////// PRODUCTION KEY ///////
export const STRIPE_PUBLISHABLE_KEY = 'pk_live_51ShfM5Fh7MkxCDnIlryBPbNOESmWUzD3TH4aqW7jT78UjAHP3ZADM9JXtFBAOkEazzSolJZESy8OOrTBStVVaXxO00iuUbeXn6';
